<template>
    <div>
        <h5 v-if="this.$slots['default']" class="tit tit--sm d-flex align-center">
            <v-img max-width="30" :aspect-ratio="30 / 24" src="/images/icon/icon-sprout.svg" class="mr-4px mr-md-8px" />
            <slot />
        </h5>
        <div v-if="this.$slots['text']" class="txt txt--xl txt--dark"><slot name="text" /></div>
        <v-divider class="grey lighten-2 my-16px my-md-24px" />
    </div>
</template>

<script>
export default {
    props: {},
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.tit + .txt {
    margin-top: 16px;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .tit + .txt {
        margin-top: 24px;
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>
